module.exports = __webpack_public_path__ + "img/ic_qmarker_tank_lbl.ba8991eb.png";